import { z } from 'zod';
import { zDocument } from './model.js';
export const JOB_NAMES = ['emailNotifications', 'generateNotifications'];
export const JOB_STATUSES = ['started', 'completed', 'failed'];
export const zJob = zDocument.extend({
    type: z.literal('job'),
    name: z.enum(JOB_NAMES),
    status: z.enum(JOB_STATUSES),
    machine: z.string(),
    params: z.record(z.union([z.string(), z.number(), z.boolean()])),
    results: z.record(z.union([z.string(), z.number(), z.boolean()])),
    error: z.string()
});
export const EmptyJob = {
    type: 'job',
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    machine: '',
    machineIP: '',
    name: 'emailNotifications',
    status: 'started',
    error: '',
    results: {},
    params: {}
};
export function isValidJobName(name) {
    return JOB_NAMES.includes(name);
}
